const CustomUserAccountKeys = {
    TITLE: "title",
    USER_ID: "userId",
    PARTY_ID: "partyId",
    VALIDITY_START_DATE: "validityStartDate",
    VALIDITY_END_DATE: "validityEndDate",
    ACTIVE: "active"
}

export default CustomUserAccountKeys